import React from "react";

import DownloadPdfButton from "../utils/DownloadPdfButton";
import { IHealthStatus } from "../../../../services/medical-history/medical-history.interface";
import { IPetItemResponse } from "../../../../services/Standard-of-care/standard-of-care.interface";
import { MIXPANEL_EVENTS } from "../../../../config/mixPanelEvents";
import PetHeaderCard from "./PetHeaderCard";
import { useMedicalRecordPdf } from "../../../../services/medical-history/medical-history.service";
import VitalsGrid from "./VitalsGrid";
import { fromUnixToFormatDate } from "../../../../utils/unix-timestamp";

type Props = {
  petData: IPetItemResponse;
  healthStatus: IHealthStatus;
};

const MedicalRecordsData = (props: Props) => {
  const { petData, healthStatus } = props;
  const { fetchMedicalRecordPdf } = useMedicalRecordPdf();

  const latestOn = healthStatus.time ?
    fromUnixToFormatDate(String(healthStatus.time)) :
    null;

  return (
    <div className="flex flex-col w-full">
      <div className="flex flex-col gap-6 max-h-[31.25rem] overflow-y-auto pr-1">
        <PetHeaderCard petData={petData} />

        <div className="flex flex-col gap-3">
          <div className="flex items-baseline justify-between px-0.5">
            <p className="geograph-medium text-[14px] leading-[20px] text-light-black">
              Health Status
            </p>
            {latestOn && (
              <p className="geograph-regular text-[12px] leading-[17px] text-gray-1">
                Latest on {latestOn}
              </p>
            )}
          </div>

          <VitalsGrid healthStatus={healthStatus} />
        </div>
      </div>

      <div className="sticky bottom-0 flex flex-col pt-3 bg-white">
        <DownloadPdfButton
          id="downloadMedicalRecordsButton"
          label="Download Full Records (PDF)"
          mixpanelEvent={MIXPANEL_EVENTS.MEDICAL_RECORDS}
          petName={petData.name}
          errorMessage="We couldn't prepare the medical record right now. Please try again."
          fetchPdf={() => fetchMedicalRecordPdf(petData.id)}
        />
      </div>
    </div>
  );
};

export default MedicalRecordsData;
